<template>
  <div>
    <div class="pane-group">
      <div class="pane-sm" >
        <h5>Select Location</h5>
        
        <nav-item v-for="(loc, i) in $locations" v-on:click="selectReport(loc)" 
        :class="loc === selectedLocation ? 'active' : ''" :key="i"
        >{{loc}}</nav-item>

        
        <h5>Select Date Period</h5>
        <nav-item class="active" v-on:click="selectReport('RCGB')">Today</nav-item>
        <nav-item class="" v-on:click="selectReport('RMGB')">Yesterday</nav-item>
        <nav-item class="" v-on:click="selectReport('WGB')">This Week</nav-item>
        <nav-item class="" v-on:click="selectReport('WGB')">Last Week</nav-item>

        <form v-on:submit.prevent="selectReport()" class="login">
          <div>
            From:
            <input v-model="from" type="text" autofocus>
          </div>
          
          <div>
            To:&nbsp;&nbsp;&nbsp;
            <input v-model="to" type="text">
          </div>
          <input type="submit" value="Search">    

        </form>
        
        
      </div>

      <div class="pane">
        <h1>{{selectedLocation}} Invoice Raw Transactions</h1>
        
        <BasicTableComponent :list="list" :formatters="listFormatters" :titles="listTitles"/>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable indent, block-spacing */
/* global axios, i_axios, moment */
export default {
  name: 'InvoiceRawTransactions',
  async created () {
    await this.selectReport('RCGB')
  },
  data () { return { 
      selectedLocation: 'RCGB',
      list: [],
      listFormatters: {},
      listTitles: {
        'ts' : 'Timestamp', 
      },
      // from: undefined,
      // to: undefined,
      from: '2018-08-08 00:04:31',
      to: '2018-08-08 07:56:54',
    } 
  },
  methods: {

    selectReport: async function (location) {
      this.selectedLocation = location === undefined ? this.selectedLocation : location;
      this.list = [];

      let response = await i_axios.post('/Reports/getRawInvoiceTranscations', { location: this.selectedLocation, from:this.from, to:this.to})

      this.list = response.data
    }
  }, 
}
</script>

<style>
  
</style>
